// MUI
import { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";

type SnackbarsContentProps = {
	critical?: boolean;
	message?: string;
	component?: ReactNode;
};

export default function SnackbarsContent(props: Readonly<SnackbarsContentProps>) {
	const { message = "", critical, component } = props;

	return (
		<Grid container className="snackbars-content" sx={{ padding: "1.5px 0" }}>
			<Grid item xs={12}>
				{critical && (
					<Typography className="regular-pt-sans-pro-narrow-label snackbars-critical" component={"span"}>
						System Error:
					</Typography>
				)}
				{message && (
					<Typography className="regular-pt-sans-pro-narrow-label snackbars-message" component={"span"}>
						{message}
					</Typography>
				)}
			</Grid>
			{component && (
				<Grid item xs={12}>
					{component}
				</Grid>
			)}
		</Grid>
	);
}
